import { render } from "./EventsNearbyCarousel.vue?vue&type=template&id=3e76973c&scoped=true&ts=true"
import script from "./EventsNearbyCarousel.vue?vue&type=script&lang=ts"
export * from "./EventsNearbyCarousel.vue?vue&type=script&lang=ts"

import "./EventsNearbyCarousel.vue?vue&type=style&index=0&id=3e76973c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e76973c"]])

export default __exports__